<table class="table table-striped">
  <thead>
    <tr>
      <th>Substituir</th>
      <th>Por</th>
      <th>Dose</th>
      <th>Unidade</th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="produto in $ctrl.insumosSelecionados track by $index">
      <td class="vertical-middle width-25">{{produto.insumo_was.descricao}}/{{produto.insumo_was.unidade.abreviatura}}</td>
      <td class="width-50">
        <span>
          <div>
            <ui-select 
              ng-model="produto.insumo"
              on-select="$ctrl.addItem(produto.insumo, $index)"
              theme="bootstrap" 
              id="produtos" 
              name="produtos"
              append-to-body="true"
              ng-disabled="$ctrl.working">

              <ui-select-match allow-clear="true" placeholder="Pesquisar produto">
                {{$select.selected.descricao}}
              </ui-select-match> 
              <ui-select-choices 
                repeat="item in $ctrl.items" 
                refresh="$ctrl.searchItems($select, $index)"
                refresh-delay="300" >

                <div ng-bind-html="item.descricao | highlight: $select.search"></div>
                <span ng-show="$root.permissions.estoque.canViewStock && $root.parametros.tem_controle_de_estoque">
                  <small ng-bind-html="'Físico: ' + (item.saldo_fisico | number:4) + ' ' + (item.unidade.abreviatura)"></small><br>
                  <small ng-bind-html="'A Receber: ' + (item.saldo_receber | number:4) + ' ' + (item.unidade.abreviatura)"></small><br>
                  <small ng-bind-html="'Em Uso: ' + (item.saldo_em_uso | number:4) + ' ' + (item.unidade.abreviatura)"></small>
                </span>
              </ui-select-choices>
            </ui-select>
            <small class="help-block" ng-show="$ctrl.currentIndex === $index && $ctrl.searchItem.length && !$ctrl.items">
              Informe pelo menos 3 caracteres
            </small>
            <span class="input-group-addon no-border no-background" ng-show="$ctrl.currentIndex === $index && !produto.loadingItems && $ctrl.items.length === 0">
              Não encontrado
            </span>
          </div>          
        </span>
        <span>
          <i class="fa fa-spinner fa-spin m-t-sm" ng-show="produto.loadingItems"></i>
        </span>
      </td>
      <td class="width-20">
        <input title="Dose" class="form-control p-xxs"
          placeholder="Dose" ng-model="produto.insumo.dose"
          fixed-decimal-input
          type="text" inputmode="decimal" required>
      </td>   
      <td class="width-5">
        <span ng-if="!!produto.insumo"> 
          <select
            ng-model="produto.insumo.unidade"
            ng-options="unidade.abreviatura for unidade in produto.insumo.unidadesCompativeis track by unidade.nomeSistema"
            class="form-control p-xxs"
          ></select>
        </span>
      </td>
    </tr>
  </tbody>
</table>

